import React from "react";
import { ReactComponent as CSS } from "../img/skill_icons/css.svg";

export const Css = () => {
  return <CSS title="css" />;
};
